import styled from 'styled-components';
import theme from '../../../../../styles/theme';
import NaviText from '../../../common/NaviText';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import Button from '../../../../common/Button';
import { useGetItemSel } from '../../../../../interface/item';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Collapse, FormControl, InputLabel, MenuItem, Select, TextField, Fade, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useGetInoutHistSel, useSetInoutHist, useGetInoutSel } from '../../../../../interface/inout';
import { useGetCodeList } from '../../../../../interface/common';
import CommonDataGrid from '../../../../common/CommonDataGrid';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useCallback } from 'react';
import { Row, TabText } from '../../../../../styles/common';
import { NumericFormat } from 'react-number-format';
import { useQuery } from 'react-query';
import { availCheck } from '../common'
import { IOT_TP, ITEM_STATUS } from '../../../../common/constants';

const MainWrap = styled.div`
    position: relative;
    // display: flex;
    // flex-direction: column;
    // justify-content: flex-start;
    width: 100%;
    height: 100%;
    overflow-y: auto;

    .naviBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid ${theme.color.black[10]};
        position:sticky;
        top:0px;
        background: ${theme.color.white[100]};
        z-index:1500;
    }

`;

const MFadePannel = styled.div`

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    border: 0;
    position: fixed;
    top: 0;
    left: 0;
    background: ${theme.color.black[60]};
    border-radius: 16px;
    z-index: 2000;
    display: flex;
    justify-content: center;
    align-items: center;
    > .pannel {
        position: relative;
        background: ${theme.color.white[100]};
        width: 340px;
        max-height: calc(80% - 80px);
        height: auto;
        padding: 16px;
        padding-top: 0;
        border-radius: inherit;
        overflow-y: auto;
    }

`;

const NumericFormatCustom = (param) => {
    return (
        <NumericFormat
        type='text'
        displayType='text'
        thousandSeparator
        isNumericString
        prefix="₩ "
        value={param.row.pur_price}
      />
    )
}

const columns = [
    { field: 'tno', headerName: '자산번호', width:140 },
    { field: 'pcat_nm', headerName: '구분', width:100 },
    { field: 'cat_nm', headerName: '분류', width:150 },
    { field: 'lot_no', headerName: '표기번호', width:120 },
    { field: 'maf_nm', headerName: '제조사', width:100 },
    { field: 'model_nm', headerName: '모델명', width:300 },
    { field: 'status_nm', headerName: '자산상태', width:100 },
    { field: 'location', headerName: '위치', width:120 },
    { field: 'model_sub', headerName: '모델유형', width:120 },
    { field: 'serial_no', headerName: '시리얼넘버', width:200 },
    { field: 'maf_date', headerName: '제조일자', width:100 },
    { field: 'pur_date', headerName: '구매일자', width:100 },
    { field: 'pur_tpnm', headerName: '구매구분', width:100 },
    { field: 'pur_price', headerName: '구매가격', width:120, renderCell:NumericFormatCustom},
    { field: 'uid1', headerName: '책임자', width:100 },
    { field: 'uid2', headerName: ' 부책임자', width:100 },
]

const inoutColumns = [
    { field: 'tno', headerName: '자산번호', flex:1 },
    { field: 'cat_nm', headerName: '분류', flex: 0.5 },
    { field: 'model_nm', headerName: '모델명', flex: 1 },
    // { field: 'o_ret_stnm', headerName: '반출상태', flex:0.5 },
    { field: 'o_reg_dt', headerName: '반출일', flex:1 },
    { field: 'i_ret_stnm', headerName: '반입상태', flex:0.5 },
    { field: 'i_reg_dt', headerName: '반입일', flex:1 },
]

const InoutHistItem = ({sno, iotNm, isIng, target : paramTarget, onClose}) => {

    const [listMode, setListMode] = useState('ALL');
    const [list, setList] = useState([]);
    const [inoutList, setInoutList] = useState([]);
    const [inWaitList, setInWaitList] = useState([]);
    const [itemToggle, setItemToggle] = useState(false);

    const [inoutModToggle, setInoutModToggle] = useState(false);

    const [modSno, setModSno] = useState(sno);

    const [target, setTarget] = useState(paramTarget);
    const [mode, setMode] = useState();

    const [priRelCheck, setPriRelCheck] = useState('A');

    const [showOdetail, setShowODetail] = useState((paramTarget && !paramTarget.i_seq) ? true : false);
    const [showIdetail, setShowIDetail] = useState((paramTarget && paramTarget.i_seq) ? true : false);

    const { data : user } = useQuery('ADMIN_USER_INFO', {});
    const { data : ioRetStList} = useGetCodeList('io_ret_st');
    const { data : itemList, isLoading:itemLoading } = useGetItemSel({});
    const { data : inoutHistList, isLoading: inoutHistLoading } = useGetInoutHistSel({sno:sno});

    const { data: selectInoutList, isError, refetch } = useGetInoutSel({is_ing:1,iot_tp:IOT_TP.SEARCH});

    const { mutate } = useSetInoutHist();
    const [errorMsg, setErrorMsg] = useState();

    useEffect(()=>{
        if(itemList){
            setList(itemList.map((item,index)=>({...item,id:index})));
        }else{
            setList([])
        }
    },[itemList])

    useEffect(()=>{
        if(target && !inoutHistLoading){

            handleItemClick(target);
            setInoutList(
                inoutHistList.map((item,index)=>(
                    {
                        ...item,
                        id:index,
                        o_reg_dt:moment(item.o_reg_dt).format('YYYY/MM/DD HH:mm'),
                        i_reg_dt:(item.i_reg_dt && item.i_reg_dt!== null) ? moment(item.i_reg_dt).format('YYYY/MM/DD HH:mm') : '',
                    }
                    )));
            const inWaitListTemp = inoutHistList.filter(item=>(!item.i_seq|| item.i_seq === null))
            setInWaitList(inWaitListTemp.map((item,index)=>(
                {
                    ...item,
                    id:index,
                    o_reg_dt : moment(item.o_reg_dt).format('YYYY/MM/DD HH:mm')
                }
            )
    ));
                
        }
    },[inoutHistList])

    const handleItemClick = (obj) => {
        const outInitOpt = {o_ret_st:'',o_contents:'',o_descr:'',o_reg_dt:''}
        const inInitOpt = {i_ret_st:'',i_contents:'',i_descr:'',i_reg_dt:''}
        if(obj && obj.tid){
            const modeItem = inoutHistList.find((histTarget)=>histTarget.tid === obj.tid);
            if(modeItem){
                const temp = {
                    ...obj,
                    ...modeItem
                }
                if(modeItem.i_seq && modeItem.iseq !== null){
                    setMode('MOD');
                    setTarget(temp);
                    setShowODetail(false);
                    setShowIDetail(false);
                }else{
                    setMode('I_WAIT');
                    setTarget({...temp,...inInitOpt});
                    setShowODetail(false);
                    setShowIDetail(true);
                } 
            }else{
                setMode('ADD');
                setTarget({...obj,...outInitOpt,...inInitOpt})
            }
        }else{
            setMode('ADD');
            setTarget({...obj,...outInitOpt,...inInitOpt})
        }
    }

    const handleValueChange = (id, val) => {
        const temp  = {...target,[id]:val}
        setTarget(temp);
    }

    const handleAddClick = useCallback((mode, addItem, priRelCheck) => {
        let checkTemp = {pri_check: false, rel_check: false};
        if(mode !== 'o' && addItem.rid && addItem.rid > 0){
            switch(priRelCheck){
                case 'P' :
                    checkTemp = {pri_check: true, rel_check: false};
                    break;
                case 'R' :
                    checkTemp = {pri_check: false, rel_check: true};
                    break;
                case 'A' :
                default :
                    break;
            }
        }
        const temp = {
            mode: 'POST',
            sno: sno,
            tid: addItem.tid,
            rid: addItem.rid,
            reg_id: user.uid,
            io_st: mode==='o' ? 'O':'I',
            ret_st: mode==='o' ? 'N': addItem.i_ret_st,
            contents: mode==='o' ? addItem.o_contents: addItem.i_contents,
            descr: mode==='o' ? addItem.o_descr: addItem.i_descr,
            ...checkTemp
        }
        mutate(
            temp,
            {
                onSuccess:()=>{
                    // handleItemClick(target)
                }
            }
            )
    })
    const handleModClick = useCallback((mode, modItem, priRelCheck) => {
        let checkTemp = {pri_check: false, rel_check: false};
        if(mode !== 'o' && modItem.rid && modItem.rid > 0){
            switch(priRelCheck){
                case 'P' :
                    checkTemp = {pri_check: true, rel_check: false};
                    break;
                case 'R' :
                    checkTemp = {pri_check: false, rel_check: true};
                    break;
                case 'A' :
                    checkTemp = {pri_check: true, rel_check: true};
                    break;
                default :
                    break;
            }
        }
        console.log(checkTemp)
        const temp = {
            mode: 'PUT',
            sno: sno,
            tid: modItem.tid,
            rid: modItem.rid,
            reg_id: user.uid,
            seq: mode==='o' ? modItem.o_seq: modItem.i_seq,
            io_st: mode==='o' ? 'O':'I',
            ret_st: mode==='o' ? modItem.o_ret_st: modItem.i_ret_st,
            contents: mode==='o' ? modItem.o_contents: modItem.i_contents,
            descr: mode==='o' ? modItem.o_descr: modItem.i_descr,
            ...checkTemp
        }
        mutate(
            temp,
            {
                onSuccess:()=>{
                    // handleItemClick(target)
                }
            }
            )
    })
    const handleDelClick = useCallback((mode,delItem) => {
        const temp = {
            mode: 'DELETE',
            sno: sno,
            seq: mode==='o' ? delItem.o_seq: delItem.i_seq,
        }
        mutate(
            temp,
            {
                onSuccess:()=>{
                    // handleItemClick(target)
                }
            }
            )
    })

    const inoutMod = () => {
        setInoutModToggle(true);
    }

    const handleSnoUpdate = useCallback((param,tsno) => {
        mutate(
            {mode:'PUT',...param, seq:param.o_seq,io_st:'O',reg_id:user.uid,sno:tsno},
            {
                onSuccess:()=>{
                    setInoutModToggle(false);
                    setTarget();
                    setMode('ADD')
                },
                onError:(e)=>{
                    // setToggle(true);
                    console.log(e.response)
                    setErrorMsg('변경에 실패하였습니다.'+e.response.data.message);
                }
            }
            )
    },[mutate]);

    return (
        <MainWrap>
            <div className='naviBar'>
                <NaviText target={[{text:'반출입'},{text:'반출입관리'},{text:iotNm},{text:'자산정보'}]} />
                <div className='close' onClick={()=>onClose(false)}>
                    <img src={`/images/ic_close.svg`} />
                </div>
            </div>
            <Row col={5} style={{marginTop:'8px'}}>
                <TextField
                    id='tno' 
                    label='자산번호' 
                    size='small' 
                    InputProps={{
                        readOnly: true,
                    }}
                    InputLabelProps={{shrink:true}} 
                    disabled
                    value={target ? target.tno : ''}
                    // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                />
                <TextField 
                        id='model_nm' 
                        label='모델명' 
                        size='small' 
                        InputProps={{
                            readOnly: true,
                        }}
                        InputLabelProps={{shrink:true}} 
                        disabled
                        value={target ? target.model_nm : ''}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                <TextField
                    label='분류'
                    InputProps={{
                        readOnly: true,
                    }}
                    InputLabelProps={{shrink:true}} 
                    size='small'
                    disabled
                    // placeholder='분류'
                    value={target ? target.cat_nm : ''}
                />
            </Row>
            <Row style={{justifyContent:'space-between'}}>
                <Row style={{margin:0,padding:0}}>
                    {/* <FormControl style={{width:'10rem'}} size='small'>
                        <InputLabel id='retSt-label'>반출상태</InputLabel>
                        <Select label="반출상태" labelId='retSt-label' size='small' value={target && target.o_ret_st}>
                            <MenuItem 
                                value={''} 
                                onClick={()=>handleValueChange('o_ret_st','')}
                            >
                                -------
                            </MenuItem>
                            {ioRetStList && ioRetStList.map((item,index)=>{
                                return <MenuItem 
                                            key={index} 
                                            value={item.code} 
                                            onClick={()=>handleValueChange('o_ret_st',item.code)}
                                        >
                                            {item.value}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl> */}
                    {(target && target.o_reg_dt) &&
                        <TextField
                            label='반출일'
                            InputProps={{
                                readOnly: true,
                            }}
                            InputLabelProps={{shrink:true}} 
                            size='small'
                            disabled
                            // placeholder='분류'
                            value={target && moment(target.o_reg_dt).format('YYYY/MM/DD HH:mm')}
                        />
                    }
                </Row>
                <Row style={{margin:0,padding:0}}>
                    {isIng===1 && mode === 'ADD' &&
                        <Button onClick={()=>handleAddClick('o',target)} style={{margin:'0',width:'100px'}}>반출</Button>
                    }
                    {isIng===1 && availCheck(user.user_tp) && mode !== 'ADD' &&
                        <Button onClick={()=>inoutMod()} style={{margin:'0',width:'100px'}}>조사변경</Button>
                    }
                    {/* {isIng===1 && mode !== 'ADD' &&
                        <Button onClick={()=>handleModClick('o',target)} style={{margin:'0',width:'100px'}}>수정</Button>
                    } */}
                    {isIng===1 && mode !== 'ADD' &&
                        <Button onClick={()=>handleDelClick('o',target)} style={{margin:'0',width:'100px'}}>삭제</Button>
                    }
                    {(mode !== 'ADD' && showOdetail === false) && <ExpandMoreIcon style={{fontSize:'2rem'}} onClick={()=>setShowODetail(true)}/>}
                    {(mode !== 'ADD' &&showOdetail === true) && <ExpandLessIcon style={{fontSize:'2rem'}} onClick={()=>setShowODetail(false)}/>}
                </Row>
            </Row>
            <Collapse in={mode==='ADD' || showOdetail}>
                <Row>
                    <TextField 
                        id='o_contents' 
                        label='내용' 
                        fullWidth 
                        multiline
                        InputLabelProps={{shrink:true}}  
                        rows={2} 
                        size='small' 
                        value={target && target.o_contents}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='o_descr' 
                        label='비고' 
                        fullWidth 
                        multiline 
                        InputLabelProps={{shrink:true}} 
                        rows={2} 
                        size='small' 
                        value={target && target.o_descr}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
            </Collapse>
            {(target && target.o_seq) &&
            <React.Fragment>
            <Row style={{justifyContent:'space-between'}}>
                <Row style={{margin:0,padding:0}}>
                    <FormControl style={{width:'10rem'}} size='small'>
                        <InputLabel id='iretSt-label'>반입상태</InputLabel>
                        <Select label="반입상태" labelId='iretSt-label' size='small' value={target && target.i_ret_st}>
                            <MenuItem 
                                value={''} 
                                onClick={()=>handleValueChange('i_ret_st','')}
                            >
                                -------
                            </MenuItem>
                            {ioRetStList && ioRetStList.map((item,index)=>{
                                return <MenuItem 
                                            key={index} 
                                            value={item.code} 
                                            onClick={()=>handleValueChange('i_ret_st',item.code)}
                                        >
                                            {item.value}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl>
                    {target.i_reg_dt &&
                        <TextField
                            label='반입일'
                            InputProps={{
                                readOnly: true,
                            }}
                            InputLabelProps={{shrink:true}} 
                            size='small'
                            disabled
                            // placeholder='분류'
                            value={target && moment(target.i_reg_dt).format('YYYY/MM/DD HH:mm')}
                        />
                    }
                    {((target.rid && target.rid > 0) && (target.i_ret_st !== '') && (target.i_ret_st !== ITEM_STATUS.NORMAL) && (target.i_ret_st !== ITEM_STATUS.NO_USE)) &&
                        <FormControl>
                            <RadioGroup
                                row
                                aria-labelledby="is_ing-label"
                                defaultValue={priRelCheck}
                                name="is_ing"
                                onChange={(e)=>setPriRelCheck(e.target.value)}
                            >
                                <FormControlLabel value={"A"} control={<Radio />} label="모두" />
                                <FormControlLabel value={"P"} control={<Radio />} label="블랙박스" />
                                <FormControlLabel value={"R"} control={<Radio />} label="배터리" />
                            </RadioGroup>
                        </FormControl>
                    }
                </Row>
                <Row style={{margin:0,padding:0}}>
                    {isIng===1 && mode === 'I_WAIT' &&
                        <Button onClick={()=>handleAddClick('i',target, priRelCheck)} style={{margin:'0',width:'100px'}}>반입</Button>
                    }
                    {isIng===1 && mode === 'MOD' &&
                        <Button onClick={()=>handleModClick('i',target, priRelCheck)} style={{margin:'0',width:'100px'}}>수정</Button>
                    }
                    {isIng===1 && mode === 'MOD' &&
                        <Button onClick={()=>handleDelClick('i',target)} style={{margin:'0',width:'100px'}}>삭제</Button>
                    }
                    {showIdetail === false && <ExpandMoreIcon style={{fontSize:'2rem'}} onClick={()=>setShowIDetail(true)}/>}
                    {showIdetail === true && <ExpandLessIcon style={{fontSize:'2rem'}} onClick={()=>setShowIDetail(false)}/>}
                </Row>
            </Row>
            <Collapse in={showIdetail}>
            <Row>
                <TextField 
                    id='i_contents' 
                    label='내용' 
                    fullWidth 
                    multiline
                    InputLabelProps={{shrink:true}}  
                    rows={2} 
                    size='small' 
                    value={target && target.i_contents}
                    onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                />
            </Row>
            <Row>
                <TextField 
                    id='i_descr' 
                    label='비고' 
                    fullWidth 
                    multiline 
                    InputLabelProps={{shrink:true}} 
                    rows={2} 
                    size='small' 
                    value={target && target.i_descr}
                    onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                />
            </Row>
            </Collapse>
            </React.Fragment>
            }
            <Row>
                <MenuOpenIcon onClick={()=>setItemToggle(!itemToggle)}/>
                자산검색 
                {itemToggle === true &&
                    <React.Fragment>
                        &nbsp;&nbsp;&nbsp;&gt;&gt;
                        <TabText selected={listMode === 'ALL'} onClick={()=>setListMode('ALL')}>전체자산</TabText>
                        <TabText selected={listMode === 'IN_OUT'} onClick={()=>setListMode('IN_OUT')}>현황</TabText>
                        <TabText selected={listMode === 'IN_WAIT'}onClick={()=>setListMode('IN_WAIT')}>반입대상</TabText>
                    </React.Fragment>
                }

            </Row>
            <Collapse in={itemToggle} >
                <div style={{width:'100%', height: '45vh', overflow:'auto'}}>
                <CommonDataGrid
                    isLoading={itemLoading}
                    list={listMode==='ALL' ? list : listMode === 'IN_WAIT' ? inWaitList : inoutList}
                    columns={listMode === 'ALL' ? columns : inoutColumns}
                    onRowClick={(e)=>{handleItemClick(e.row)}}
                    />
                    </div>
            </Collapse>
            <Fade in={inoutModToggle}>
                <MFadePannel>
                    <div className='pannel'>
                        <div className='naviBar' >
                            <NaviText target={[{text:'반출입'},{text:'반출입관리'}, {text:'조사변경'}]} />
                            <div className='close' style={{top:'24px',right:'16px'}} onClick={()=>setInoutModToggle(false)}>
                                <img src={`/images/ic_close.svg`} />
                            </div>
                        </div>
                        <div style={{height:'16px'}} />
                        <FormControl style={{width:'100%'}} size='small'>
                            <InputLabel id='iotNm-label'>과업명</InputLabel>
                            <Select label="과업명" labelId='iotNm-label' size='small' value={modSno}>
                                {selectInoutList && selectInoutList.map((item,index)=>{
                                    return <MenuItem 
                                                key={index} 
                                                value={item.sno} 
                                                onClick={()=>setModSno(item.sno)}
                                            >
                                                {item.iot_nm}
                                            </MenuItem>
                                })}
                            </Select>
                        </FormControl>
                        <h3 style={{color:theme.color.secondary.red, height:'1rem',margin:0,padding:8,lineHeight:'1rem'}}>{errorMsg}</h3>
                        <Row style={{marginTop:'16px'}}><Button style={{margin:0,width:'100%'}} onClick={()=>handleSnoUpdate(target,modSno)}>변경</Button></Row>
                    </div>
                </MFadePannel>
            </Fade>
        </MainWrap>
    )
}

export default InoutHistItem;